module.exports = __webpack_public_path__ + "img/empty.cc77660d.png";